// extracted by mini-css-extract-plugin
export var button = "Button-module--button--12841";
export var icon = "Button-module--icon--1b1ac";
export var icon_back = "Button-module--icon_back--9eac0";
export var lgBreak = "1200";
export var mdBreak = "992";
export var smBreak = "768";
export var variant_primary = "Button-module--variant_primary--91b7d";
export var variant_primary_outline = "Button-module--variant_primary_outline--fafbd";
export var variant_secondary = "Button-module--variant_secondary--a37c7";
export var variant_secondary_solid = "Button-module--variant_secondary_solid--4b930";
export var xsBreak = "480";